import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode"; // Ensure this is properly installed
import accountActions from "../store/actions/accounts/account.actions";

// 0015: useAccount is now a PURE READER. The single fetch of UserInfo happens once in
// <AppBootstrap/> via React Query (deduped + cached) and is bridged into Redux. This hook no
// longer triggers any network request — it only reads account state and exposes logout /
// validateToken. The expired-token -> logout side effect moved to <AppBootstrap/>. Return shape
// is unchanged so every existing consumer keeps working.
const useAccount = () => {
  const dispatch = useDispatch();
  const { token, isAuthenticated, isLoggedIn, userInfo } = useSelector((state) => state.accountReducer);

  // Decode and validate the JWT token
  const validateToken = useCallback(() => {
    if (!token) return false;

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      return decodedToken.exp > currentTime; // Check if token is still valid
    } catch (err) {
      console.error("Invalid token:", err);
      return false;
    }
  }, [token]);

  // Logout user
  const logout = useCallback(() => {
    dispatch(accountActions.logout());
  }, [dispatch]);

  return {
    isLoggedIn,
    isTokenValid: validateToken(),
    userInfo,
    token,
    isAuthenticated,
    logout,
    validateToken,
  };
};

export default useAccount;
